import { render, staticRenderFns } from "./westDrug.vue?vue&type=template&id=96a0de3a&scoped=true"
import script from "./westDrug.vue?vue&type=script&lang=js"
export * from "./westDrug.vue?vue&type=script&lang=js"
import style0 from "./westDrug.vue?vue&type=style&index=0&id=96a0de3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a0de3a",
  null
  
)

export default component.exports